module.exports = __webpack_public_path__ + "img/zhichao.b55bef80.png";